import type { ContentFilter } from '../../config/content-types';
import { useHorizontalOverflow } from './useHorizontalOverflow';

const FILTERS: Array<{ id: ContentFilter; label: string }> = [
  { id: 'all', label: 'Tất cả' },
  { id: 'slide', label: 'Slide' },
  { id: 'video', label: 'Video' },
  { id: 'assessment', label: 'BKT' },
];

export interface TypeChipsProps {
  value: ContentFilter;
  onChange: (value: ContentFilter) => void;
}

// four pills overflow 260px, so the row scrolls sideways
export function TypeChips({ value, onChange }: TypeChipsProps) {
  const { ref, faded, measure } = useHorizontalOverflow();
  return (
    <div className="h-scroll lib-chips">
      <div className="h-scroll__track" ref={ref} onScroll={measure} role="group" aria-label="Lọc loại bài giảng">
        {FILTERS.map((filter) => (
          <button type="button" key={filter.id} aria-pressed={value === filter.id} className={value === filter.id ? 'is-active' : ''} onClick={() => onChange(filter.id)}>{filter.label}</button>
        ))}
      </div>
      {faded ? <span className="h-scroll__fade" aria-hidden={true} /> : null}
    </div>
  );
}
